import React from 'react';

import PropTypes from 'prop-types';
import {
    Grid,
    ButtonGroup,
    Button,
    makeStyles,
    IconButton,
} from '@material-ui/core';
import ButtonStyle from 'styles/theme/Button';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import MenuIcon from '@material-ui/icons/Menu';
import moment from 'moment';
import { MEDIA_QUERY } from 'utils/enum/Core';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2),
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            marginBottom: theme.spacing(1),
        },
    },
    title: {
        placeSelf: 'center',
        width: '200px',
        textAlign: 'center',
        fontSize: '1.5rem',
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            width: '120px',
            fontSize: '0.875rem',
        },
    },
    calendarTitle: {
        display: 'flex',
        flexDirection: 'row',
    },
    navigationButton: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            minWidth: '40px',
            padding: theme.spacing(0.5),
        },
    },
    viewButtonGroup: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            '& button': {
                fontSize: '0.7rem',
                padding: theme.spacing(0.5, 0.75),
                minWidth: 'auto',
            },
        },
    },
    todayButton: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            fontSize: '0.75rem',
            padding: theme.spacing(0.5, 1),
        },
    },
    hamburgerButton: {
        display: 'none',
        marginRight: theme.spacing(1),
        [`@media (max-width: ${MEDIA_QUERY.W_992}px)`]: {
            display: 'inline-flex',
        },
    },
    todayGroup: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    weekButton: {
        [`@media (max-width: ${MEDIA_QUERY.W_992}px)`]: {
            display: 'none !important',
        },
    },
    listWeekButton: {
        display: 'none',
        [`@media (max-width: ${MEDIA_QUERY.W_992}px)`]: {
            display: 'inline-flex',
        },
    },
    ...ButtonStyle.getStyle(theme),
}));

const NAV_GROUP = {
    NEXT: 'NEXT',
    PREVIOUS: 'PREV',
    GO_TODAY: 'TODAY',
};

const VIEW_GROUP = {
    MONTH: {
        value: 'MONTH',
        view: 'dayGridMonth',
    },
    WEEK: {
        value: 'WEEK',
        view: 'timeGridWeek',
    },
    DAY: {
        value: 'DAY',
        view: 'timeGridDay',
    },
    LIST_WEEK: {
        value: 'LIST_WEEK',
        view: 'listWeek',
    },
};

const Toolbar = (props) => {
    const classes = useStyles();
    const {
        onClickNavigationGroup,
        onClickViewGroup,
        currentDate,
        currentView,
        onToggleDrawer,
    } = props;

    return (
        <Grid
            alignItems="flex-end"
            container
            justify="space-between"
            spacing={3}
            className={classes.root}
        >
            <Grid item xs={12} sm="auto">
                <div className={classes.todayGroup}>
                    <ButtonGroup>
                        <Button
                            className={`${classes.outlinedInfo} ${classes.todayButton}`}
                            onClick={() => onClickNavigationGroup(NAV_GROUP.GO_TODAY)}
                        >
                            Today
                        </Button>
                    </ButtonGroup>
                    <IconButton
                        className={classes.hamburgerButton}
                        onClick={onToggleDrawer}
                        size="small"
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
            </Grid>
            <Grid item xs={12} sm="auto">
                <div className="d-flex-center">
                    <Button
                        variant="text"
                        className={classes.navigationButton}
                        onClick={() => onClickNavigationGroup(NAV_GROUP.PREVIOUS)}
                    >
                        <KeyboardArrowLeftIcon />
                    </Button>
                    <h3 className={classes.title}>{moment(currentDate).format('MMMM YYYY')}</h3>
                    <Button
                        variant="text"
                        className={classes.navigationButton}
                        onClick={() => onClickNavigationGroup(NAV_GROUP.NEXT)}
                    >
                        <KeyboardArrowRightIcon />
                    </Button>
                </div>
            </Grid>
            <Grid item xs={12} sm="auto">
                <ButtonGroup className={classes.viewButtonGroup}>
                    <Button
                        className={VIEW_GROUP.MONTH.value === currentView.value ? classes.containedInfo : classes.outlinedInfo}
                        onClick={() => onClickViewGroup(VIEW_GROUP.MONTH)}
                    >
                        Month
                    </Button>
                    <Button
                        className={`${VIEW_GROUP.WEEK.value === currentView.value ? classes.containedInfo : classes.outlinedInfo} ${classes.weekButton}`}
                        onClick={() => onClickViewGroup(VIEW_GROUP.WEEK)}
                    >
                        Week
                    </Button>
                    <Button
                        className={`${VIEW_GROUP.LIST_WEEK.value === currentView.value
                            ? classes.containedInfo : classes.outlinedInfo} ${classes.listWeekButton}`}
                        onClick={() => onClickViewGroup(VIEW_GROUP.LIST_WEEK)}
                    >
                        List Week
                    </Button>
                    <Button
                        className={VIEW_GROUP.DAY.value === currentView.value ? classes.containedInfo : classes.outlinedInfo}
                        onClick={() => onClickViewGroup(VIEW_GROUP.DAY)}
                    >
                        Day
                    </Button>
                </ButtonGroup>
            </Grid>
        </Grid>
    );
};

Toolbar.propTypes = {
    currentDate: PropTypes.object.isRequired,
    currentView: PropTypes.object.isRequired,
    onClickNavigationGroup: PropTypes.func.isRequired,
    onClickViewGroup: PropTypes.func.isRequired,
    onToggleDrawer: PropTypes.func,
};

Toolbar.defaultProps = {
    onToggleDrawer: () => null,
};

export default Toolbar;
